module.exports = __webpack_public_path__ + "9943b1e80b39a33fbcb0e74ec6d0414e.svg";